import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import httpInterceptor from "../../common/APIConfig";

const initialState = {
  resources: [],
  count: 0,
  loading: false,
  isloaded: false,
  error: false,
  errorMessage: null,
  errorAccountId: null,
};

export const getAllAWSVms = createAsyncThunk(
  "getAllAWSVms",
  async (accountId, { rejectWithValue }) => {
    try {
      const response = await httpInterceptor.get(
        `/resources/aws/ec2?account=${accountId}`
      );
      if (response.status === 200) {
        return { accountId: accountId, vms: response.data.vms };
      }
    } catch (error) {
      console.log(error);
      if (!error.response) {
        return rejectWithValue(error.message);
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllAWSVmsSlice = createSlice({
  name: "getAllAWSVms",
  initialState,
  error: null,
  reducers: {
    resetGetAllAWSVmsError: (state) => {
      state.error = false;
      state.errorMessage = null;
      state.errorAccountId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAWSVms.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.errorMessage = null;
      state.errorAccountId = null;
    });
    builder.addCase(getAllAWSVms.fulfilled, (state, action) => {
      state.loading = false;
      state.resources = action.payload;
      state.isloaded = true;
      state.error = false;
      state.errorAccountId = null;
    });
    builder.addCase(getAllAWSVms.rejected, (state, action) => {
      state.loading = false;
      state.errorMessage = action.payload;
      state.isloaded = true;
      state.error = true;
      state.errorAccountId =
        action.meta && action.meta.arg ? action.meta.arg : null;
    });
  },
});

export const { resetGetAllAWSVmsError } = getAllAWSVmsSlice.actions;

export default getAllAWSVmsSlice.reducer;
